import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import AutoDistributionBolt from './icon-auto-distribution-bolt.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <AutoDistributionBolt {...validProps} />;
}
SvgComponent.iconName = 'autoDistributionBolt';

export const AutoDistributionBoltIcon = svgIconWrapper(SvgComponent);
